import {Component, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from "@angular/material/snack-bar";
import {DialogData} from "../dialog/DialogData";
import {any} from "async";


@Component({
   selector: 'app-snack',
   templateUrl: './snack.component.html',
   styleUrls: ['./snack.component.scss']
})
export class SnackComponent implements OnInit {

   title: any;
   msg: any;
   err: any;
   html: any;
   subMsg: any;
   typeDialog: any;
   icon: any;
   titleButton: any;
   actionButton?: {
      text: string,
      onClick: ()=>any
   } = {
      text: "Entra",
      onClick: ()=>any
   }

   // @Output() outputChoice = new EventEmitter<any>()

   constructor(@Inject(MAT_SNACK_BAR_DATA) public data: DialogData,
               public snackBarRef: MatSnackBarRef<SnackComponent>) {
      this.title = data.title
      this.msg = data.msg
      this.err = data.err
      this.html = data.html
      this.typeDialog = data.typeDialog || 'success'
      this.subMsg = data.subMsg
      this.icon = data.icon || 'done'
      this.titleButton = data.titleButton
      this.actionButton = data.actionButton
   }

   ngOnInit(): void {
      console.log(this.data)
   }

   outputEvent(){
     return true
   }

   dismiss(){
      this.snackBarRef.dismiss()
   }

}
